import * as React from "react";
import Box from "@material-ui/core/Box";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { Modal } from "@material-ui/core";
import { Fade } from "@material-ui/core";
import { Backdrop } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { URI_PREFIX, URI } from "../../constants/index";
import { asyncGet, asyncPost } from "../../common/utils";
import Title from "../Title";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import {
  OTP_TYPES,
  PURPOSE,
  REQUESTER_TYPES,
  HIP_REQUESTER_ID,
  UNLINKED_CARE_CONTEXT,
  HMIS_DATA,
} from "../../constants/dataconstants";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  RESEND_OTP_TIMEOUT,
  RESEND_OTP_CHANCE,
} from "../../constants/dataconstants";
import { alignProperty } from "@mui/material/styles/cssUtils";

const steps = [
  "Search Patient",
  "Select Care Context & Make Authentication",
  "Confirm Authentication",
  "Submit Care Context",
];

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  stepper: {
    display: "flex",
    "& .MuiStepIcon-active": { color: global.secondaryColour },
    "& .MuiStepIcon-completed": { color: global.secondaryColour },
    "& .Mui-disabled .MuiStepIcon-root": { color: "#ccc" },
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  title: {
    flexGrow: 1,
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    backgroundColor: "#f2efda",
    padding: theme.spacing(10),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    padding: theme.spacing(5),
  },
  modalStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    border: "0px solid #000",
  },
}));

export default function GenerateAbhaByAadhaar() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const [showAadhaar, setShowAadhaar] = React.useState(true);
  const [selectedConsentApproval, setConsentApproval] = React.useState(true);
  const [healthId, setHealthId] = React.useState("");
  const [demographicInfo, setDemographicInfo] = React.useState({});
  const [unlinkedCareContexts, setUnlinkedCareContexts] = React.useState([]);
  const [authMode, setAuthMode] = React.useState("");
  const [fetchModes, setFetchModes] = React.useState(new Set());
  const [modalData, setModalData] = React.useState("");
  const [modalState, setModalState] = React.useState(false);
  const [showLoader, setShowLoader] = React.useState(false);
  const [authCode, setAuthCode] = React.useState("");
  const [careContexts, setCareContexts] = React.useState([]);
  const [hospInfo, setHospInfo] = React.useState({});
  const [message, setMessage] = React.useState("");
  const [hmisCareContexts, setHmisCareContexts] = React.useState([]);
  const [patDOB, setPatientDOB] = React.useState("");
  const [buttonText, setButtonText] = React.useState("RESEND OTP");
  const [resendOtpChance, setResendOtpChance] = React.useState(0);
  const [intervalId, setIntervalId] = React.useState(null);

  const resendOtpButtontext = () => {
    let count = parseInt(resendOtpChance);
    let i = RESEND_OTP_TIMEOUT;
    if (i > 0) {
      const id = setInterval(() => {
        count >= RESEND_OTP_CHANCE
          ? setButtonText("CANNOT USE RESEND OTP")
          : setButtonText("RESEND OTP AFTER: " + i);
        i = i - 1;
        if (i < 0) {
          count++;
          i = RESEND_OTP_TIMEOUT;
          setResendOtpChance(count.toString());
          count > RESEND_OTP_CHANCE
            ? setButtonText("CANNOT USE RESEND OTP")
            : setButtonText("RESEND OTP");
          clearInterval(id); // Clear interval using local variable
        }
      }, 1000);
      setIntervalId(id); // Save intervalId in state
    }
  };

  const onSearchPatient = async () => {
    var decryptedInstituteId;
    setShowLoader(true);
    if (healthId.trim() == "") {
      setShowLoader(false);
      setModalData("ABHA Address can't be blank");
      setModalState(true);
      return false;
    }
    const __oo = {
      txt: global.instituteId,
    };
    const res = await asyncPost(
      URI.decryptString,
      __oo,
      true,
      true,
      global.token
    );
    if (res.status == 2000) {
      decryptedInstituteId = res.data.txt;
    }
    const url =
      global.m2BasePathUrl +
      global.m2GetCareContextUrl +
      "?HealthID=" +
      healthId +
      "&UserID=0&HipID=" +
      decryptedInstituteId;
    let resFindPatientHmis =
      global.clientId === 5
        ? await asyncGet(url, false, null, true, false)
        : await asyncGet(url, false, null, false, false);
    console.log(
      "resFindPatientHmis JSON.stringify: " + JSON.stringify(resFindPatientHmis)
    );
    if (
      resFindPatientHmis.hasOwnProperty("lstModel") &&
      resFindPatientHmis.lstModel !== null
    ) {
      resFindPatientHmis = resFindPatientHmis.lstModel;
    }

    console.log("resFindPatientHmis2  : " + JSON.stringify(resFindPatientHmis));
    if (resFindPatientHmis && resFindPatientHmis.length > 0) {
      //debugger;
      let unlinkedCareContexts = [];
      let demographicInfo = {};
      let hospInfo = {};

      hospInfo.NINNumber = resFindPatientHmis[0].ninNumber;
      hospInfo.HospitalCode = resFindPatientHmis[0].hospitalCode;
      setHospInfo(hospInfo);

      demographicInfo.HealthID = resFindPatientHmis[0].healthID;
      demographicInfo.HealthIDNumber = resFindPatientHmis[0].healthIDNumber;
      demographicInfo.MobileNo = resFindPatientHmis[0].mobileNo;
      demographicInfo.Gender = resFindPatientHmis[0].gender;
      demographicInfo.BirthYear = resFindPatientHmis[0].birthYear;
      demographicInfo.Name = resFindPatientHmis[0].name;
      demographicInfo.Regdate = resFindPatientHmis[0].regdate;
      demographicInfo.RegNo = resFindPatientHmis[0].regNo;

      setDemographicInfo(demographicInfo);
      // setHealthId(resFindPatientHmis[0].HealthID);

      resFindPatientHmis.map((item) => {
        console.log(item);
        let objUnlinkCC = {};

        objUnlinkCC.selected = false;
        objUnlinkCC.slno = item.slno;
        objUnlinkCC.CareContextID = item.careContextID;
        if (
          item.hasOwnProperty("careContextNo") &&
          item.careContextNo !== null &&
          item.careContextNo.trim() !== ""
        ) {
          objUnlinkCC.CareContexNo = item.careContextNo;
        } else {
          objUnlinkCC.CareContexNo = item.careContexNo;
        }
        objUnlinkCC.CareContextDesc = item.careContextDesc;
        objUnlinkCC.NINNumber = item.ninNumber;
        objUnlinkCC.HospitalCode = item.hospitalCode;
        objUnlinkCC.RegNo = item.regNo;
        objUnlinkCC.Regdate = item.regdate;
        objUnlinkCC.CareContextDate = item.careContextDate;
        objUnlinkCC.CareContextType = item.careContextType;
        objUnlinkCC.CareContextRefID = item.careContextRefID;

        // objUnlinkCC.slno = item.slno;
        // objUnlinkCC.CareContextID = item.CareContextID;
        // objUnlinkCC.CareContexNo = item.CareContexNo;
        // objUnlinkCC.CareContextDesc = item.CareContextDesc;
        // objUnlinkCC.NINNumber = item.NINNumber;
        // objUnlinkCC.HospitalCode = item.HospitalCode;
        // objUnlinkCC.RegNo = item.RegNo;
        // objUnlinkCC.Regdate = item.Regdate;
        // objUnlinkCC.CareContextDate = item.CareContextDate;
        // objUnlinkCC.CareContextType = item.CareContextType;
        // objUnlinkCC.CareContextRefID = item.CareContextRefID;
        unlinkedCareContexts.push(objUnlinkCC);
      });

      global.unlinkedCareContexts = unlinkedCareContexts;
      setUnlinkedCareContexts([...unlinkedCareContexts]);
      // setShowLoader(false);
      const __oo = {
        healthId: healthId.indexOf("@sbx") != -1 ? healthId : healthId + "@sbx",
        // healthId: healthId.indexOf("@abdm") != -1 ? healthId : healthId + "@abdm",
        purpose: "KYC_AND_LINK",
        requesterType: REQUESTER_TYPES[0].value,
        requesterId: global.instituteId,
      };
      // debugger;
      // const res = await asyncPost(URI.userAuthFetchModes, __oo, true, true, global.token)
      // if (res && res.status == 2000) {//debugger;
      //   global.requestId = res.data.requestId
      //   // setRequestId(res.data.requestId);
      //   let fetmodes = [
      //     "AADHAAR_OTP",
      //     "MOBILE_OTP",
      //     "DEMOGRAPHICS",
      //     "DIRECT"
      //   ]
      //   setFetchModes(fetmodes);
      //   // setTimeout(function () { getFetchModes(); }, 8000);
      //   handleNext();
      // }
      let fetmodes = ["AADHAAR_OTP", "MOBILE_OTP", "DEMOGRAPHICS", "DIRECT"];
      setFetchModes(fetmodes);
      setShowLoader(false);
      // setTimeout(function () { getFetchModes(); }, 8000);
      handleNext();
    } else {
      setShowLoader(false);
      setModalData(
        "Message from ABDM : Unable to find the respective patient.\nAnd it's respective Care Contexts"
      );
      setModalState(true);
      return false;
    }
  };

  //To search Patient with the given ABHA or the Health ID
  const onSearchPatient2 = async () => {
    setShowLoader(true);
    if (healthId.trim() == "") {
      setShowLoader(false);
      setModalData("Health Id can't be blank");
      setModalState(true);
      return false;
    }
    const __oo = {
      healthId: healthId,
      hipID: global.instituteId,
    };

    let resFindPatientHmis = await asyncPost(
      URI.integratorGetCareContext,
      __oo,
      true,
      true,
      global.token
    );
    if (
      resFindPatientHmis.data != null ||
      resFindPatientHmis.data != "" ||
      resFindPatientHmis.data > 0
    ) {
      let unlinkedCareContexts = [];
      let demographicInfo = {};
      let hospInfo = {};

      hospInfo.NINNumber = resFindPatientHmis.data[0].ninNumber;
      hospInfo.HospitalCode = resFindPatientHmis.data[0].hospitalCode;
      setHospInfo(hospInfo);

      demographicInfo.HealthID = resFindPatientHmis.data[0].healthID;
      demographicInfo.HealthIDNumber =
        resFindPatientHmis.data[0].healthIDNumber;
      demographicInfo.MobileNo = resFindPatientHmis.data[0].mobileNo;
      demographicInfo.Gender = resFindPatientHmis.data[0].gender;
      demographicInfo.BirthYear = resFindPatientHmis.data[0].birthYear;
      demographicInfo.Name = resFindPatientHmis.data[0].name;
      demographicInfo.Regdate = resFindPatientHmis.data[0].regdate;
      demographicInfo.RegNo = resFindPatientHmis.data[0].regNo;

      setDemographicInfo(demographicInfo);
      // setHealthId(resFindPatientHmis[0].HealthID);

      resFindPatientHmis.data.map((item) => {
        console.log(item);
        let objUnlinkCC = {};

        objUnlinkCC.selected = false;
        objUnlinkCC.slno = item.slno;
        objUnlinkCC.CareContextID = item.careContextID;

        if (
          item.hasOwnProperty("careContextNo") &&
          item.careContextNo !== null &&
          item.careContextNo.trim() !== ""
        ) {
          objUnlinkCC.CareContexNo = item.careContextNo;
        } else {
          console.log(item.careContexNo);
          objUnlinkCC.CareContexNo = item.careContexNo;
        }
        objUnlinkCC.CareContextDesc = item.careContextDesc;
        objUnlinkCC.NINNumber = item.ninNumber;
        objUnlinkCC.HospitalCode = item.hospitalCode;
        objUnlinkCC.RegNo = item.regNo;
        objUnlinkCC.Regdate = item.regdate;
        objUnlinkCC.CareContextDate = item.careContextDate;
        objUnlinkCC.CareContextType = item.careContextType;
        objUnlinkCC.CareContextRefID = item.careContextRefID;
        unlinkedCareContexts.push(objUnlinkCC);
      });

      global.unlinkedCareContexts = unlinkedCareContexts;
      setUnlinkedCareContexts([...unlinkedCareContexts]);
      // setShowLoader(false);
      const __oo = {
        healthId: healthId.indexOf("@sbx") != -1 ? healthId : healthId + "@sbx",
        // healthId: healthId.indexOf("@abdm") != -1 ? healthId : healthId + "@abdm",
        purpose: "KYC_AND_LINK",
        requesterType: REQUESTER_TYPES[0].value,
        requesterId: global.instituteId,
      };
      let fetmodes = ["AADHAAR_OTP", "MOBILE_OTP", "DEMOGRAPHICS", "DIRECT"];
      setFetchModes(fetmodes);
      setShowLoader(false);
      // setTimeout(function () { getFetchModes(); }, 8000);
      handleNext();
    } else {
      setShowLoader(false);
      setModalData(
        "Message from ABDM : Unable to find the respective patient.\nAnd it's respective Care Contexts"
      );
      setModalState(true);
      return false;
    }
  };
  //To fetch the different modes of Authentication of the user & show them in the add care context part.
  const getFetchModes = async () => {
    const __oo = {
      requestId: global.requestId,
    };
    // debugger;
    const res = await asyncPost(
      URI.getFetchModes,
      __oo,
      true,
      true,
      global.token
    );
    if (res && res.status == 2000) {
      setShowLoader(false);
      let fetchModes = res.data.modes;
      let index = fetchModes.indexOf("PASSWORD");
      if (index > -1) {
        fetchModes.splice(index, 1);
      }
      index = fetchModes.indexOf("EMAIL_OTP");
      if (index > -1) {
        fetchModes.splice(index, 1);
      }
      setFetchModes([...fetchModes]);
      handleNext();
    } else {
      setShowLoader(false);
      handleNext();
    }
  };
  //Making the checked care context selected value true.
  const handleCheckedCC = (id, value) => {
    //debugger;
    let unlinkedCareContexts = global.unlinkedCareContexts;
    unlinkedCareContexts.map((item) => {
      if (item.CareContextID == id) {
        item.selected = value;
        console.log("Selected Care Context: ", item.CareContextID);
      }
    });
    // debugger;
    // global.unlinkedCareContexts = unlinkedCareContexts;
    setUnlinkedCareContexts([...unlinkedCareContexts]);
  };
  //To initialize the process of authentication in care context
  const onVerify = async (isResend) => {
    clearInterval(intervalId);
    if (isResend) {
      var count = parseInt(resendOtpChance);
      count++;
      setResendOtpChance(count);
    }
    let arr = unlinkedCareContexts.filter((e) => e.selected == true);
    if (authMode == null || authMode == "") {
      setModalData("Please select an auth mode to make authentication.");
      setModalState(true);
      return false;
    } else {
      if (arr.length > 0) {
        setShowLoader(true);
        // onAddCareContext();
        const __oo = {
          healthId:
            healthId.indexOf("@sbx") != -1 ? healthId : healthId + "@sbx",
          purpose: PURPOSE[0].value,
          authMode: authMode, //OTP_TYPES[1].value,
          requesterType: REQUESTER_TYPES[0].value,
          requesterId: global.instituteId,
        };
        // debugger;
        const res = await asyncPost(
          URI.userAuthInit,
          __oo,
          true,
          true,
          global.token
        );
        if (res && res.status == 2000) {
          global.requestId = res.data.requestId;
          setShowLoader(false);
          if (authMode !== "DEMOGRAPHICS") resendOtpButtontext();
          if (!isResend) handleNext();
        } else {
          setShowLoader(false);
          setModalData(
            "Message from ABDM : Unable to verify the ABHA Address\n" +
              res.ndhmErrorMsg.message +
              "\n" +
              res.ndhmErrorMsg.details[0].message
          );
          setModalState(true);
          return false;
        }
      } else {
        setModalData(
          "Message from ABDM : Please select minimum one care context to proceed."
        );
        setModalState(true);
        return false;
      }
    }
  };
  //To Authenticate the user after selection of care context on basis of Aadhar OTP and Mobile OTP.
  const onConfirm = async () => {
    onAddCareContext();
    setShowLoader(true);
    const __oo = {
      requestId: global.requestId,
      authCode: authCode,
    };
    // debugger;
    const res = await asyncPost(
      URI.userAuthConfirm,
      __oo,
      true,
      true,
      global.token
    );
    if (res && res.status == 2000) {
      //debugger;
      let requestId = res.data.requestId;
      global.requestId = requestId;
      clearInterval(intervalId);
      // setRequestId([...requestId]);
      console.log("userAuthConfirm requestId : " + global.requestId);
      setTimeout(function () {
        onSubmitCareContext();
      }, 10000);
    } else {
      setShowLoader(false);
      setModalData(
        "Message from ABDM : Unable to verify the ABHA Address\n" +
          res.ndhmErrorMsg.message +
          "\n" +
          res.ndhmErrorMsg.details[0].message
      );
      setModalState(true);
      return false;
    }
  };
  //To Authenticate user after selection of care context on the basis of Demographica mode of authentication
  const onDemographicsConfirm = async () => {
    onAddCareContext();
    if (patDOB.trim() == "") {
      alert("Please enter the date of birth.");
    } else {
      setShowLoader(true);
      const __oo = {
        requestId: global.requestId, //requestId,
        name: demographicInfo.Name,
        gender:
          demographicInfo.Gender && demographicInfo.Gender != ""
            ? demographicInfo.Gender.trim()
            : "",
        dateOfBirth: patDOB,
        identifierType: "MOBILE",
        identifierValue: demographicInfo.MobileNo,
      };
      // debugger;
      const res = await asyncPost(
        URI.userAuthDemographicsConfirm,
        __oo,
        true,
        true,
        global.token
      );
      if (res && res.status == 2000) {
        //debugger;

        let requestId = res.data.requestId;
        global.requestId = requestId;
        // setRequestId([...requestId]);
        setTimeout(function () {
          onSubmitCareContext();
        }, 10000);
      } else {
        setShowLoader(false);
        setModalData(
          "Message from ABDM : Unable to confirm the authentication.\n" +
            res.ndhmErrorMsg.message +
            "\n" +
            res.ndhmErrorMsg.details[0].message
        );
        setModalState(true);
        return false;
      }
    }
  };

  const onAddCareContext = () => {
    //debugger;
    let ccList = [];
    let hmisCCList = [];
    unlinkedCareContexts.map((item) => {
      if (item.selected) {
        const __oo = {
          referenceNumber: item.CareContexNo,
          display: item.CareContextDesc,
        };
        ccList.push(__oo);
        console.log("Unlinked Care Contexts:--", ccList);
        const __hmisCC = {
          referenceNumber: item.CareContexNo,
          display: item.CareContextDesc,
        };
        hmisCCList.push(__hmisCC);
      }
    });
    global.careContexts = ccList;
    setCareContexts([...ccList]);
    setHmisCareContexts([...hmisCCList]);
    console.log(global.careContexts);
  };
  //To authenticate the user automatically with the selected care context via PHR method
  const onSubmitCareContext = async () => {
    //debugger;
    const __oo = {
      requestId: global.requestId,
      patientRefNumber: demographicInfo.RegNo,
      displayText: demographicInfo.Name,
      careContexts: global.careContexts,
    };
    console.log("Care Context Request >>> " + __oo);
    // debugger;
    const res = await asyncPost(
      URI.addCareContext,
      __oo,
      true,
      true,
      global.token
    );
    if (res && res.status == 2000) {
      //debugger;
      setTimeout(function () {
        checkAddCCWebhook(res.data.requestId);
      }, 20000);
      // alert("Care context added successfully.");
    } else {
      //debugger;
      setShowLoader(false);
      let msg = "Unable to add care context.";
      setMessage([...msg]);
      handleNext();
      setModalData(
        "Message from ABDM : Unable to add the chosen Care-Context/Care-Contexts\n" +
          res.ndhmErrorMsg.message +
          "\n" +
          res.ndhmErrorMsg.details[0].message
      );
      setModalState(true);
      return false;
    }
  };
  //To Authenticate user after selection of care context on the basis of PHR mode of authentication
  const onDirectAddCareContext = async () => {
    //debugger;
    const __oo = {
      requestId: global.requestId,
      patientRefNumber: demographicInfo.RegNo,
      displayText: demographicInfo.Name,
      careContexts: global.careContexts,
    };
    setShowLoader(true);
    console.log("Care Context Request >>> " + __oo);
    // debugger;
    const res = await asyncPost(
      URI.addCareContext,
      __oo,
      true,
      true,
      global.token
    );
    if (res && res.status == 2000) {
      //debugger;
      setTimeout(function () {
        checkAddCCWebhook(res.data.requestId);
      }, 20000);
    } else {
      //debugger;
      setShowLoader(false);
      let msg = "Unable to add care context.";
      setMessage([...msg]);
      handleNext();
      setModalData(
        "Message from ABDM :" +
          res.ndhmErrorMsg.message +
          "\n" +
          res.ndhmErrorMsg.details[0].message
      );
      setModalState(true);
      return false;
    }
  };

  //To check whether ABDM Server has sent data to our application as per our User requirements
  const checkAddCCWebhook = async (requestId) => {
    //debugger;
    const url = URI.getWebhookResponse + "?requestId=" + requestId;
    const resWebhook = await asyncGet(url, true, global.token, true, false);
    if (resWebhook && resWebhook.status == 2000) {
      //debugger;
      let resData = JSON.parse(resWebhook.data.webhookResponse);
      console.log(resData);
      if (
        resData.hasOwnProperty("acknowledgement") &&
        resData.acknowledgement
      ) {
        checkAndUpdateHmis();
        setShowLoader(false);
        let msg = "Care context added successfully.";
        setMessage([...msg]);
        handleNext();
      } else if (resData.hasOwnProperty("error")) {
        setShowLoader(false);
        let msg = resData.error.message;
        checkAndUpdateHmis();
        setMessage([...msg]);
        handleNext();
      } else {
        setShowLoader(false);
        let msg = "Unable to add care context from Webhook.";
        setMessage([...msg]);
        handleNext();
      }
    } else {
      setShowLoader(false);
      checkAndUpdateHmis();
      let msg = "Care Context has been added. Please check PHR App.";
      setMessage([...msg]);
      handleNext();
    }
  };
  const UpdateHmisCall = async (__oo) => {
    const res1 = await asyncPost(
      global.m2BasePathUrl + global.m2UpdateCareContextUrl,
      __oo,
      true,
      false,
      ""
    );
    console.log("res1 : " + res1);
  };
  const UpdateHmisCall2 = async (__oo) => {
    const res1 = await asyncPost(
      URI.integratorUpdateCareContext,
      __oo,
      true,
      true,
      global.token
    );
    console.log("res1 : " + res1);
  };

  const checkAndUpdateHmis = async () => {
    //debugger;
    var _careContext = [];
    if (global.careContexts.length > 0) {
      global.careContexts.map((item) => {
        _careContext.push({
          referenceNumber: item.referenceNumber,
        });
      });
      console.log("For Updating the linked Care Context:", _careContext);
      if (global.updateCareContextOldMethod === 0) {
        const __oo = {
          UserID: "12345",
          HipID: global.instituteId,
          _careContext: _careContext,
        };
        UpdateHmisCall(__oo);
      } else {
        UpdateHmisCall(_careContext);
      }
    }
  };
  const handleModalOpen = () => {
    setModalState(true);
  };
  const handleModalClose = () => {
    setModalState(false);
  };

  const isStepOptional = (step) => {
    return step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleShowAadhaar = () => {
    setShowAadhaar(!showAadhaar);
  };

  const handleConsentApproval = () => {
    setConsentApproval(!selectedConsentApproval);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const generateScreen = () => {
    if (activeStep == 0) {
      return populateScreenFlowOne();
    } else if (activeStep == 1) {
      return populateScreenFlowTwo();
    } else if (activeStep == 2) {
      return populateScreenFlowThree();
    } else if (activeStep == 3) {
      return populateScreenFlowFour();
    } else if (activeStep == 4) {
      return populateScreenFlowFive();
    }
  };

  const populateScreenFlowOne = () => {
    return (
      <form className={classes.form} noValidate>
        <Grid
          container
          direction={"row"}
          spacing={2}
          alignItems="center"
          justifyContent="center"
        >
          <Grid item>
            <TextField
              id="healthId"
              variant="standard"
              label="ABHA Address"
              type="search"
              required
              style={{ width: 300 }}
              onChange={(e) => setHealthId(e.target.value)}
            />
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              style={{
                backgroundColor: global.secondaryColour,
                color: "#fff",
                paddingBottom: 10,
                marginTop: 7,
              }}
              onClick={() => onSearchPatient()}
            >
              Search
            </Button>
          </Grid>
        </Grid>
      </form>
    );
  };

  const populateScreenFlowTwo = () => {
    return (
      <form className={classes.form} noValidate>
        <Grid container direction={"column"} spacing={2}>
          <Grid item>
            <Title>
              <span style={{ color: global.secondaryColour }}>
                Patient Info
              </span>
            </Title>
            <Table size="big">
              <TableBody>
                <TableRow>
                  <TableCell style={{ textAlign: "left" }}>
                    <strong>Name</strong>
                  </TableCell>
                  <TableCell style={{ textAlign: "left" }}>
                    <span style={{ color: "#f53169d9", fontWeight: "bold" }}>
                      {demographicInfo.Name}
                    </span>
                  </TableCell>
                  <TableCell style={{ textAlign: "left" }}>
                    <strong>Gender</strong>
                  </TableCell>
                  <TableCell style={{ textAlign: "left" }}>
                    <span style={{ color: "#f53169d9", fontWeight: "bold" }}>
                      {" "}
                      {demographicInfo.Gender &&
                      demographicInfo.Gender.trim().toUpperCase() === "M"
                        ? "Male"
                        : "Female"}
                    </span>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ textAlign: "left" }}>
                    <strong>Year Of Birth</strong>
                  </TableCell>
                  <TableCell style={{ textAlign: "left" }}>
                    <span style={{ color: "#f53169d9", fontWeight: "bold" }}>
                      {demographicInfo.BirthYear}
                    </span>
                  </TableCell>
                  <TableCell style={{ textAlign: "left" }}>
                    <strong>Mobile</strong>
                  </TableCell>
                  <TableCell style={{ textAlign: "left" }}>
                    <span style={{ color: "#f53169d9", fontWeight: "bold" }}>
                      {demographicInfo.MobileNo}
                    </span>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid>
          <Grid item>
            <Title>
              <span style={{ color: global.secondaryColour }}>
                List of Care Context
              </span>
            </Title>
            <Table size="small" style={{ paddingTop: "10px" }}>
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>
                    <strong>Care Context Id</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Description</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {unlinkedCareContexts.map((row) => (
                  <TableRow>
                    <TableCell>
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="selected"
                            checked={row.selected}
                            onChange={(e) =>
                              handleCheckedCC(
                                row.CareContextID,
                                e.target.checked
                              )
                            }
                          />
                        }
                        label=""
                        style={{ color: global.secondaryColour }}
                      />
                    </TableCell>
                    <TableCell>{row.CareContexNo}</TableCell>
                    <TableCell>{row.CareContextDesc}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Grid>
          <Grid item>
            <Title>
              <span style={{ color: global.secondaryColour }}>
                Make Authentication
              </span>
            </Title>
            <Grid
              container
              direction={"row"}
              spacing={2}
              alignItems="center"
              justifyContent="center"
            >
              <Grid item>
                <InputLabel id="loginAsLabel">Auth Mode</InputLabel>
                <Select
                  fullWidth
                  labelId="authMode"
                  id="authMode"
                  value={authMode}
                  onChange={(e) => {
                    setAuthMode(e.target.value);
                  }}
                  className={classes.selectEmpty}
                  style={{ width: 300 }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {fetchModes.map((row) => (
                    <MenuItem value={row}>{row}</MenuItem>
                  ))}
                </Select>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: global.secondaryColour,
                    color: "#fff",
                    marginTop: "10px",
                  }}
                  onClick={() => onVerify(false)}
                >
                  GO
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    );
  };

  const populateScreenFlowThree = () => {
    return (
      <form className={classes.form} noValidate>
        <Title>
          <div
            className="text-center"
            style={{ color: global.secondaryColour }}
          >
            {authMode == "DEMOGRAPHICS"
              ? "Enter Demographic Details & Confirm Request"
              : authMode == "DIRECT"
              ? "Consent has been sent to PHR App. Please approve and confirm."
              : "Confirm Request by Entering OTP."}
          </div>
        </Title>
        <Grid
          container
          direction={"row"}
          spacing={2}
          columns={{ xs: 4, sm: 8, md: 12 }}
          alignItems="center"
          justifyContent="center"
        >
          <Grid item>
            <item>
              {authMode == "DEMOGRAPHICS" ? (
                <TextField
                  id="patDOB"
                  value={patDOB}
                  type="date"
                  label="Date Of Birth"
                  required
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setPatientDOB(e.target.value)}
                />
              ) : authMode == "DIRECT" ? (
                ""
              ) : (
                <TextField
                  id="authCode"
                  label="OTP"
                  type="text"
                  required
                  inputProps={{ maxLength: 6 }}
                  onChange={(e) => setAuthCode(e.target.value)}
                />
              )}
            </item>
          </Grid>
          <Grid item>
            <Grid>
              {authMode == "DEMOGRAPHICS" ? (
                <Grid item justifyContent="center" alignItems="center">
                  <item>
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: global.secondaryColour,
                        color: "#fff",
                      }}
                      onClick={() => onDemographicsConfirm()}
                    >
                      Verify and Proceed
                    </Button>
                  </item>
                </Grid>
              ) : authMode == "DIRECT" ? (
                <Grid item>
                  <item>
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: global.secondaryColour,
                        color: "#fff",
                      }}
                      onClick={() => onDirectAddCareContext()}
                    >
                      Confirm
                    </Button>
                  </item>
                </Grid>
              ) : (
                <Grid
                  container
                  direction={"row"}
                  spacing={1}
                  alignItems="center"
                  justifyContent="center"
                >
                  <Grid item>
                    <item>
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: global.secondaryColour,
                          color: "#fff",
                          paddingBottom: 10,
                        }}
                        onClick={() => onConfirm()}
                      >
                        Confirm
                      </Button>
                    </item>
                  </Grid>
                  <Grid item>
                    <item>
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor:
                            buttonText === "RESEND OTP"
                              ? global.secondaryColour
                              : "#ccc",
                          color: "#fff",
                          paddingBottom: 10,
                        }}
                        onClick={() => onVerify(true)}
                        disabled={buttonText === "RESEND OTP" ? false : true}
                      >
                        {buttonText}
                      </Button>
                    </item>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid item>
            {authMode == "DEMOGRAPHICS" ? (
              ""
            ) : (
              <item
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                }}
              >
                {resendOtpChance === 3 ? (
                  ""
                ) : (
                  <span>
                    You can resend OTP{" "}
                    <span style={{ color: "#D20062" }}>
                      {resendOtpChance > 0
                        ? parseInt(RESEND_OTP_CHANCE) -
                          parseInt(resendOtpChance) +
                          1
                        : 2}
                    </span>{" "}
                    more times
                  </span>
                )}
              </item>
            )}
          </Grid>
        </Grid>
      </form>
    );
  };

  const populateScreenFlowFour = () => {
    return (
      <div style={{ textAlign: "center", marginTop: 100 }}>
        <h5>{message}</h5>
        <br></br>
        <Button
          variant="contained"
          className="mx-2 "
          style={{
            backgroundColor: global.secondaryColour,
            color: "#fff",
          }}
          onClick={() => handleReset()}
        >
          Back To Home
        </Button>
      </div>
    );
  };

  const populateScreenFlowFive = () => {
    // return (
    //   <form className={classes.form} noValidate>
    //     <Grid container direction={"column"} spacing={2}>
    //       <Grid item>
    //         <TextField id="email" value={email} label="Email" style={{ marginTop: -6, width: 500 }} type="text" InputLabelProps={{ shrink: true }} onChange={(e) => setEmail(e.target.value)} />
    //       </Grid>
    //       <Grid item>
    //         <TextField id="healthId" value={healthId} label="Health Id" style={{ marginTop: -6, width: 500 }} type="text" InputLabelProps={{ shrink: true }} onChange={(e) => setHealthId(e.target.value)} />
    //       </Grid>
    //       <Grid item>
    //         <Button variant="contained" style={{
    //   backgroundColor: global.secondaryColour,
    //   color: "#fff",
    // }} onClick={() => generateAbhaId()}>Generate ABHA ID</Button>
    //       </Grid>
    //     </Grid>
    //   </form>
    // )
  };

  return (
    <React.Fragment>
      <Paper className={classes.paper} style={{ padding: "5px" }}>
        <Stepper activeStep={activeStep} className={classes.stepper}>
          {steps.map((label, index) => {
            const stepProps = {};
            const labelProps = {};
            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        {activeStep === steps.length ? (
          <React.Fragment>
            <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
              <Box sx={{ flex: "1 1 auto" }} />
            </Box>
          </React.Fragment>
        ) : (
          <React.Fragment>
            {showLoader ? (
              <div style={{ textAlign: "center", marginTop: 60 }}>
                <CircularProgress style={{ color: global.secondaryColour }} />
                <h5 style={{ marginTop: 5 }}>Loading...</h5>
              </div>
            ) : (
              generateScreen()
            )}
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                pt: 2,
                marginRight: 20,
              }}
            >
              <Button
                color="inherit"
                disabled={activeStep === 0}
                onClick={handleBack}
                sx={{ mr: 1 }}
              >
                Back
              </Button>
            </Box>
          </React.Fragment>
        )}
      </Paper>
      <Modal
        open={modalState}
        onClose={() => handleModalClose()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={modalState}>
          <Box
            className={classes.modalStyle}
            style={{
              background: "white",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 10,
              padding: "15px",
            }}
          >
            <h5 id="transition-modal-title">Information</h5>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              <pre>{modalData}</pre>
            </Typography>
            <Button
              variant="contained"
              style={{
                backgroundColor: global.secondaryColour,
                color: "#fff",
                paddingBottom: 10,
                marginTop: 7,
              }}
              onClick={() => handleModalClose()}
            >
              OK
            </Button>
          </Box>
        </Fade>
      </Modal>
    </React.Fragment>
  );
}
